import CardCommon from '@op/components/CardCommon';
import React, { useMemo } from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import useCompareKeyMetricsColumns from '@op/components/TableCommonHook/hooks/useCompareKeyMetricsColumns';
import { SteamOptionsType, TableHeight } from '../../constants';
import { dealWithSteamTable } from '../../utils';
import { useCompareKeyMetricsTable } from '../../hooks';
import { useDownloadParams } from '@op/hooks/useDownloadParams';

export default function PRTable({
  filter,
  tab,
  gameData,
}: {
  filter: any;
  tab: SteamOptionsType;
  gameData: {
    [id: string]: {
      name: string;
      color: string;
    };
  }[];
}) {
  const { downloadLegacy, downloading } = useDownloadParams();

  const params = useMemo(
    () => ({
      ...filter,
      stats_types: ['game_store'],
      tab_type: 'steam',
      by_type: tab,
    }),
    [filter, tab],
  );

  const { tableRecords, loading } = useCompareKeyMetricsTable({
    filter: params,
    dealwithToTable: dealWithSteamTable,
    gameData,
    defaultSortKey: 'all_reviews',
  });

  const { columns, sortColumns } = useCompareKeyMetricsColumns({
    oneKey: 'Steam',
    twoKey: tab,
    gameData,
    tableRecords,
    filter,
  });

  return (
    <CardCommon
      contentCard
      className="mentions-sentiment-table-wrapper"
      hasDownload
      loading={loading}
      loadingHeight={265}
      downloadLoading={downloading}
      handleDownloadOnClick={() => {
        downloadLegacy({
          params: {
            ...params,
            gameData,
          },
          downloadFunc: 'getOverviewCompetitorTable',
          sheetName: 'Compare Key Metrics Steam Table',
          simpleName: 'Compare Key Metrics Steam Table',
        });
      }}
      logBtnId="Steam Game Store Table"
    >
      <TableCommonHook
        columns={columns}
        hasPageable={false}
        maxHeight={TableHeight.BELOW}
        sortColumns={sortColumns}
        records={tableRecords}
        bordered="all"
        sortType={'local'}
        logBtnId="Steam Game Store"
      ></TableCommonHook>
    </CardCommon>
  );
}
